import React from "react";
import "./CareerJobs.css";
import ContactSection from "./ContactSection";
import FraudWarning from "../FraudWarning";  
import JobRole from "./JobRole";

export default function CareerJobs() {
  return (
    <>
      {/* SECTION 1 – HERO */}
      <section
        className="career-hero"
        style={{ backgroundImage: "url(/images/lll.jpeg)" }}
      >
        <div className="career-hero-text">
          <h1>Job Opportunities</h1>
          <p>Build your career with a growing and supportive team</p>
        </div>
      </section>

      {/* SECTION 2 – CONTENT */}
      <section className="career-content">
        <div className="career-text">
          <h2>Job Openings</h2>
          <span className="career-line"></span>

          <p>
       Build your future with one of India’s growing companies in Insurance, Finance & Wealth Management. At AERLIS, we believe in nurturing talent, providing professional training, and creating leaders for tomorrow. We encourage innovation, responsibility, and continuous
            growth in a positive work culture.
          </p>

          <p>
            We are looking for motivated professionals who are passionate about
            learning and contributing to long-term success. Join us and grow
            together.
          </p>
        </div>

        <div className="career-image">
          <img src="/images/ouropen.jpg" alt="Career growth" />
        </div>
        
      </section>
      <JobRole />
         {/* 🔹 CONTACT SECTION */}

              <ContactSection />
                 {/* 🔹 FRAUD / IRDAI WARNING */}
                    <FraudWarning />
    </>
  );
}
